import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FilterControls} from "../interface/filter-controls";
import {FilterProductPreview} from "../interface/filter-product-preview";
import {FilterService} from "../service/filter.service";
import {FilterControlOption} from "../interface/filter-control-option";
import {FilterCsvMetadataService} from "../service/filter-csv-metadata.service";
import {FilterOption} from "../interface/filter-option";
import {FilterControl} from "../interface/filter-control";

@Component({
	selector: 'fb-filter-container',
	templateUrl: './filter-container.component.html',
	styleUrls: ['./filter-container.component.scss']
})

export class FilterContainerComponent implements OnChanges {

	@Output()
	public onControlsChange: EventEmitter<null> = new EventEmitter<null>();

	@Input()
	public result: FilterProductPreview[] = [];

	@Input()
	public showClearFilterButton: boolean = false;

	@Input()
	public selectedFilters: FilterControlOption[] = [];

	@Input()
	public controls: FilterControls = {} as FilterControls;

	public inStockControl: FilterControl = {} as FilterControl;


	public onFilterControlChange(): void {
		this.onControlsChange.next(null);
	}

	ngOnChanges(changes: SimpleChanges): void {
		if(this.controls.cohorts) {
			this.controls.cohorts.forEach(cohort => {
				if(cohort.key.type === 'toggle') {
					this.inStockControl = cohort;
				}
			})
		}
	}
}
